import React from 'react';
import { BloatProtocolPage } from './pages/BloatProtocolPage';
export function App() {
  return <BloatProtocolPage data-id="element-0" />;
}